import { render, staticRenderFns } from "./WarningBox.vue?vue&type=template&id=7f715a5e&scoped=true"
import script from "./WarningBox.vue?vue&type=script&lang=js"
export * from "./WarningBox.vue?vue&type=script&lang=js"
import style0 from "./WarningBox.vue?vue&type=style&index=0&id=7f715a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f715a5e",
  null
  
)

export default component.exports